import { createAction, props } from '@ngrx/store';

import { AccountActionTypes } from './actions.model';

export const init = createAction(AccountActionTypes.Init);
export const destroyed = createAction(AccountActionTypes.Destroyed);

export const languageUpdated = createAction(
  AccountActionTypes.LanguageUpdated,
  props<{ locale: string }>()
);
